import React from 'react';
import {
    HomeDashboard as HomeDashboardView,
    ChoosePackage as ChoosePackageView,
    Payment as PaymentView,
    PaymentComplete as PaymentCompleteView,
    PaymentCompleteAdditional as PaymentCompleteAdditionalView,
    ChooseWorkshop as ChooseWorkshopView,
    ChooseAdditionalWorkshop as ChooseAdditionalWorkshopView,
    AbstractList as AbstractListView,
    AbstractSubmissionCreate as AbstractSubmissionCreateView,
    AbstractSubmissionEdit as AbstractSubmissionEditView,
    MyQR as MyQRView,
    HotelReservation as HotelReservationView,
    HotelPayment as HotelPaymentView,
    AdditionalPayment as AdditionalPaymentView,
    MyInvoice as MyInvoiceView,
} from 'views/Dashboard';

const routes = [
    {
        path: '/dashboard',
        element: <HomeDashboardView />,
    },
    {
        path: '/dashboard/choose-package',
        element: <ChoosePackageView />,
    },
    {
        path: '/dashboard/hotel-reservation',
        element: <HotelReservationView />,
    },
    {
        path: '/dashboard/hotel-payment',
        element: <HotelPaymentView />,
    },
    {
        path: '/dashboard/my-qr',
        element: <MyQRView />,
    },
    // {
    //   path: '/dashboard/my-certificate',
    //   element: <MyCertificateView />
    // },
    {
        path: '/dashboard/payment',
        element: <PaymentView />,
    },
    {
        path: '/dashboard/payment-complete',
        element: <PaymentCompleteView />,
    },
    {
        path: '/dashboard/payment-complete-additional',
        element: <PaymentCompleteAdditionalView />,
    },
    {
        path: '/dashboard/my-invoice',
        element: <MyInvoiceView />,
    },
    {
        path: '/dashboard/choose-workshop',
        element: <ChooseWorkshopView />,
    },
    {
        path: '/dashboard/choose-additional-workshop',
        element: <ChooseAdditionalWorkshopView />,
    },
    {
        path: '/dashboard/additional-payment',
        element: <AdditionalPaymentView />,
    },
    {
        path: '/dashboard/abstract-list',
        element: <AbstractListView />,
    },
    {
        path: '/dashboard/abstract-create',
        element: <AbstractSubmissionCreateView />,
    },
    {
        path: '/dashboard/abstract-edit/:id',
        element: <AbstractSubmissionEditView />,
    },
];

export default routes;
